import { render, staticRenderFns } from "./look_freight.vue?vue&type=template&id=2e6c9a98&scoped=true"
import script from "./look_freight.vue?vue&type=script&lang=js"
export * from "./look_freight.vue?vue&type=script&lang=js"
import style0 from "./look_freight.vue?vue&type=style&index=0&id=2e6c9a98&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6c9a98",
  null
  
)

export default component.exports